<div class="subBlockContainer">
  <div class="subBlockContent">
    <child-header
      [title]="title"
      (closeEvent)="close()"
      [showDownload]="true"
      [disableDownload] ="loadContent && !posReports.length && !hasEmptyFilterResult" 
      [titleDownload]="'Download Excel'" 
      (downloadEvent)="downloadReports()" 
      [showClone]=true titleClone="Copy Download Link" (cloneEvent)="copySellThroughReportLink()">
    </child-header>
    <div class="inner-subBlock-wrapper">
      <!-- <div class="page-title-wrapper">
        <div class="title blade-title-font">
          {{title}} 
        </div>
        <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
      </div> -->
      
        <div id="basic-info-wrapper">
          <div style="margin-bottom: 20px;" class="row filter-wrapper">
            <div class="col input-position" >
                <div class="searchInputGroup">
                  <div class="searchIcon">
                    <img src="../../images/new_ui/filter.png">
                  </div>
                  <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''"
                    onblur="this.placeholder='Filter'" [(ngModel)]="searchField" (ngModelChange)="onChange()">
                </div>
            </div>
            <div class="col col-large">
             From Date:
              <div class="searchInputGroup">
                <div class="searchIcon" (click)="dateFrom.toggle()">
                  <img src="../../images/new_ui/date.png">
                </div>
                <input id="dateFrom" class="searchInput date-picker" type="text" [(ngModel)]="fromDate" placeholder="Date"
                  mame="datePicker" ngbDatepicker  #dateFrom="ngbDatepicker" (click)="dateFrom.toggle()">
              </div>
            </div>
            <div class="col col-large">
              To Date:
              <div class="searchInputGroup">
                <div class="searchIcon" (click)="dateTo.toggle()">
                  <img src="../../images/new_ui/date.png">
                </div>
                <input id="dateTo" class="searchInput date-picker" type="text" [(ngModel)]="toDate" placeholder="Date"
                  mame="datePicker" ngbDatepicker #dateTo="ngbDatepicker" (click)="dateTo.toggle()">

              </div>
            </div>
            <div class="col col-small button-position">
              <button class="button button-red button-mid margin-top-10" id="btnSearch" (click)="searchReports();">Apply</button>
            </div>
            <!-- <div class="col col-small">
              <div id="btnDownload" class="basic-icon download-icon download-icon-position" placement="top" ngbTooltip="Download Excel" (click)="downloadReports()"></div>
            </div> -->
          </div>
        </div>

        <div *ngIf="loadContent && posReports.length > 0 && sortedData.length > 0 && !hasEmptyFilterResult">
          <div class="shared-outer-wrapper table-header-allign" *ngIf="posReports?.length">
            <table matSort (matSortChange)="sortData($event)">
              <thead>
                <tr class="row order-title-wrapper">
                  <th class="col" style="min-width: 50%" >DESCRIPTION</th>
                  <th class="col" >INVOICE NO</th>
                  <th class="col" >INVOICE DATE</th>
                  <th class="col" style="max-width: 5%;text-align: left;padding-left: 5px;padding-right: 0px;">QTY</th>
                  <th class="col" >UNIT (ex GST)</th>
                  <th class="col" >LINE (ex GST)</th>
                </tr>
              </thead>
            </table>
            <!-- <pagination-controls (pageChange)="p = $event" directionLinks="true" previousLabel="" nextLabel="" class="search-pagination"
              *ngIf="showPager"></pagination-controls> -->
          </div>
          <div class="shared-outer-wrapper child-body" *ngIf="posReports?.length">
            <table matSort (matSortChange)="sortData($event)">
              <thead hidden="true">
                <tr class="row order-title-wrapper">
                  <th class="col" style="min-width: 50%" >DESCRIPTION</th>
                  <th class="col" >INVOICE NO</th>
                  <th class="col" >INVOICE DATE</th>
                  <th class="col" style="max-width: 5%;text-align: left;padding-left: 5px;padding-right: 0px;">QTY</th>
                  <th class="col" >UNIT (ex GST)</th>
                  <th class="col" >LINE (ex GST)</th>
                </tr>
              </thead>
              <tbody class="scrollable-table-body">
                <ng-container>
                  <ng-container *ngFor="let report of sortedData | TableFilterMultiple:['stockDescription', 'invoiceNumber', 'invoiceDate', 'stockCode', 'serialNumber'] : searchField">
                    <tr class="row table-content-padding">

                      <td class="col-md" style="min-width: 50%">
                        <div class="row result_desc">
                            {{report?.stockDescription}}
                        </div>
                        <div class="row result-info">
                           <span class="bold-text">STOCK CODE: </span> {{report?.stockCode}} | <span class="bold-text"> SERIAL: </span> {{report?.serialNumber}} | <span class="bold-text"> BRAND: </span> {{report?.brand}}
                        </div>
                      </td>

                      <td class="col-md" style="padding-left: 20px">{{report?.invoiceNumber}}</td>
                      <td class="col-md">{{report?.invoiceDate}}</td>
                      <td class="col-md" style="max-width: 5%">{{report?.transQty}}</td>
                      <td class="col-md align-right" style="padding-right: 12px;">{{report?.unitPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                      <td class="col-md align-right" style="padding-right: 0px;">{{report?.linePrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                    </tr>
                  </ng-container>
                </ng-container>
              </tbody>
            </table>
            <!-- <pagination-controls (pageChange)="p = $event" directionLinks="true" previousLabel="" nextLabel="" class="search-pagination"
              *ngIf="showPager"></pagination-controls> -->
          </div>
        </div>

        <ng-container *ngIf=" loadContent && hasEmptyFilterResult">
          <div class="noResult-wrapper">
            <div><img src="../images/new_ui/no-found.png"></div>
            <div>No results found</div>
            <div>Sorry, that search or filter combination has no results.<br>Please try different criteria.</div>
            <button (click)="filterReset()" class="button button-red button-large">Try again</button>
            <div class="noResult-feedback">Send feedback</div>
          </div>
          <div class="top-divider"></div>
        </ng-container>

        <div class="inner-subBlock-wrapper" *ngIf="loadContent && !posReports.length && !hasEmptyFilterResult">
              <div class="noData-wrapper">
                <div>
                    <img src="../../images/new_ui/no-subscription.png">
                  </div>
                <label class="noData-label">
                    WE COULDN'T FIND ANY <br/>
                    INVOICES FOR GIVEN DATE RANGE
              </label>
              <br/>
              
              </div>
        </div>
        <loading-screen *ngIf="!loadContent" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)"></loading-screen>

    </div>
  </div>
</div>
